import { FilterDefault, FilterPrice } from "@repo/components";
import { Accordion } from "@repo/ui";
const Facets = props => {
  const {
    facets
  } = props;
  const getFilterComponent = (key, label, options, min, max) => {
    switch (key) {
      case "price":
        return <FilterPrice min={min} max={max} type={key} />;
      // all filters will be coming in default component also any other new facet will also take default component
      // if the UI is not different then we will popuplate the facet option data in default otherwise there will be a separate component
      default:
        return <FilterDefault options={options} type={key} />;
    }
  };
  const accordionItems = facets?.map(facet => {
    const {
      key,
      label,
      options,
      min,
      max
    } = facet || {};
    const filterComponent = getFilterComponent(key, label, options, min, max);
    return {
      title: label,
      content: filterComponent
    };
  });

  // Create an array of indices for all accordion items to be opened initially
  const initialOpenIndices = accordionItems?.map((_, index) => index);
  return <Accordion items={accordionItems} initialOpenIndices={initialOpenIndices} itemContentClass="mb-3" data-sentry-element="Accordion" data-sentry-component="Facets" data-sentry-source-file="Facets.jsx" />;
};
export default Facets;